module.exports = __webpack_public_path__ + "static/media/Google-Play.87e13635.svg";